// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-icon{fill:currentColor;display:block;height:100%;width:100%}.ui-icon.ui-icon--x-small{height:10px;width:10px}.ui-icon.ui-icon--small{height:16px;width:16px}.ui-icon.ui-icon--medium{height:24px;width:24px}.ui-icon.ui-icon--large{height:32px;width:32px}.ui-icon.ui-icon--x-large{height:48px;width:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
